import { inject } from '@angular/core';
import { 
  ActivatedRouteSnapshot, 
  Router, 
  CanActivateFn,
  RedirectCommand,
  UrlTree
} from '@angular/router';
import { UserService } from '../services/user_service';

export const existUserGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const userService = inject(UserService);
  const router = inject(Router);

  const notFoundUrl: UrlTree = router.parseUrl('/404');
  const userIdent = route.params['userIdent'] || route.params['userId'] || route.params['userIdOrName'] || null;
  
  if (userIdent) {
    return userService.getUserProfile(userIdent).then(user => {
      if (user && user.id !== '') {
        return true;
      } else {
        return new RedirectCommand(notFoundUrl);
      }
    }).catch(() => {
      return new RedirectCommand(notFoundUrl);
    });
  } else {
    return Promise.resolve(new RedirectCommand(notFoundUrl));
  }
};